import { useEffect } from 'react';
import R from 'ramda';
import { VTO_IFRAME_BUTTONS_SHIFT } from '../config';
import { getVtoControlsHeight } from '../helpers';

export const useVtoInitialisation = ({
  setVtoScriptLoaded,
  currentBreakpoint,
  setVtoControlsHeight,
  isXSmallBreakpoint,
  isSmallBreakpoint,
  isMediumBreakpoint,
  isLargeBreakpoint,
  perfectModuleLanguage,
  disabledEmailSharing,
  enableFBSharing,
  generateMultiColorControls,
}) => {
  useEffect(() => {
    if (window) {
      window.ymkAsyncInit = () => {
        const isXSmallBreakpointValue = isXSmallBreakpoint({
          currentBreakpoint,
        });
        const isSmallBreakpointValue = isSmallBreakpoint({ currentBreakpoint });
        const isDesktopVtoVersion =
          isMediumBreakpoint({ currentBreakpoint }) ||
          isLargeBreakpoint({ currentBreakpoint });

        let iframeSizes;
        const vtoControlsHeight = getVtoControlsHeight({
          isDesktopVtoVersion,
          generateMultiColorControls,
        });
        const desktopVersionVtoMargin = 70;

        if (
          (isXSmallBreakpointValue || isSmallBreakpointValue) &&
          !!window.document.body.requestFullscreen
        ) {
          iframeSizes = {
            height: window.innerHeight - vtoControlsHeight,
          };
        } else if (isXSmallBreakpointValue || isSmallBreakpointValue) {
          iframeSizes = {
            height:
              window.document.documentElement.clientHeight - vtoControlsHeight,
          };
        } else {
          iframeSizes = {
            height:
              window.document.documentElement.clientHeight -
              vtoControlsHeight -
              desktopVersionVtoMargin,
            width: 600,
          };
        }

        YMK.init({
          ...iframeSizes,
          enableEmailSharing: !disabledEmailSharing,
          SenenableUserNailReplacement: true,
          language: perfectModuleLanguage || 'enu',
          rightButtonBottomOffset: VTO_IFRAME_BUTTONS_SHIFT,
          enableFBSharing,
          enableWhatsAppSharing: 'false',
        });

        setVtoControlsHeight({ vtoControlsHeight });
        setVtoScriptLoaded({ vtoScriptLoaded: true });
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentBreakpoint,
    setVtoScriptLoaded,
    isXSmallBreakpoint,
    isSmallBreakpoint,
    isMediumBreakpoint,
    isLargeBreakpoint,
    setVtoControlsHeight,
  ]);
};

export const useInitialApplyMakeupBySku = ({
  vtoActualProductSku,
  isVtoLoaded,
}) =>
  useEffect(() => {
    if (window && window.YMK && vtoActualProductSku) {
      window.YMK.applyMakeupBySku(vtoActualProductSku);
    }
  }, [vtoActualProductSku, isVtoLoaded]);

export const useSetActualProductData = ({
  actualProductSku,
  isActualVariantExcluded,
  setVtoActualProductSlug,
  setVtoActualProductSku,
  vtoProducts,
  excludedProductsVariantsSkus,
}) =>
  useEffect(() => {
    if (!isActualVariantExcluded) {
      const actualProduct = R.find(
        (product) =>
          !!R.find(
            R.propEq('sku', actualProductSku),
            R.propOr([], 'variants', product)
          ),
        vtoProducts
      );

      if (actualProduct) {
        setVtoActualProductSlug({
          actualProductSlug: R.prop('slug', actualProduct),
        });
        setVtoActualProductSku({ actualProductSku });
      }
    } else {
      const actualProduct = R.find(
        (product) =>
          !!R.find(
            R.propEq('sku', actualProductSku),
            R.propOr([], 'variants', product)
          ),
        vtoProducts
      );

      if (actualProduct) {
        const excludedVariantIndex = R.indexOf(
          R.find(
            R.propEq('sku', actualProductSku),
            R.propOr([], 'variants', actualProduct)
          ),
          R.prop('variants', actualProduct)
        );

        let index = excludedVariantIndex;
        let variant = null;

        while (!variant) {
          const actualVariant = R.path(['variants', index], actualProduct);
          const actualVariantSku = R.prop('sku', actualVariant);

          if (!R.includes(actualVariantSku, excludedProductsVariantsSkus)) {
            variant = actualVariant;
          }

          if (index === R.path(['variants', 'length'], actualProduct) - 1) {
            index = 0;
          } else {
            index += 1;
          }
        }

        setVtoActualProductSlug({
          actualProductSlug: R.prop('slug', actualProduct),
        });
        setVtoActualProductSku({ actualProductSku: R.prop('sku', variant) });
      }
    }
    // eslint-disable-next-line
  }, [
    actualProductSku,
    isActualVariantExcluded,
    setVtoActualProductSlug,
    setVtoActualProductSku,
  ]);
